import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import AdditionalRecipients from "../../../../_utils/AccountCreationComponents/AdditionalRecipients";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import BankDetails from "../../../../_utils/AccountCreationComponents/BankDetails";
import CategoriesEdit from "../../../../_utils/AccountCreationComponents/CategoriesEdit";
import ContactDetails from "../../../../_utils/AccountCreationComponents/ContactDetails";
import GstDetails from "../../../../_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../_utils/AccountCreationComponents/PanDetails";
import CommonLayout from "../../../../_utils/CommonLayout";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";

const BeneficiaryAccountStepConfirm = ({
  payload,
  selectedFields,
  categories,
  recipients,
  manualVirtualAccount,
}) => {
  return (
    <>
      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base max-w-tab-width-normal w-full mx-auto Qsmd:!pb-padding-md">
        <CommonLayout>
          <div className="flex flex-col gap-gap-md Qsmd:pb-padding-md">
            <PanDetails
              previewMode={true}
              panNumber={payload.panNumber}
              legalName={payload.legalName}
            />

            <GstDetails
              previewMode={true}
              gstin={payload?.gstin}
              gst_org_name={payload?.gst_org_name}
            />

            {manualVirtualAccount && (
              <div>
                <ConfidentialCard
                  icon={ICONS.VIRTUAL_ACCOUNT}
                  title={globalText?.MARK_VIRTUAL_ACCOUNT}
                  note={globalText?.VIRTUAL_ACCOUNT_NOTE}
                  toggleState={manualVirtualAccount}
                  isPreview={true}
                />
              </div>
            )}

            <BankDetails
              payload={payload}
              manualVirtualAccount={manualVirtualAccount}
              previewMode={true}
            />
          </div>
          <div className="flex flex-col gap-gap-md">
            <ContactDetails
              previewMode={true}
              payload={payload}
              accountName={payload?.account_name}
              contactNumber={payload?.contact_no}
              emailId={payload?.email_id}
            />

            <CategoriesEdit
              sortedCategories={categories}
              selectedCategories={selectedFields}
              Title="Categories"
              isPreview={true}
            />

            <AssignLabels
              previewMode={true}
              labels={payload?.labels}
              isOptional={true}
            />

            <div className="pb-padding-md">
              <AdditionalRecipients
                previewMode={true}
                recipients={recipients}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default BeneficiaryAccountStepConfirm;
